module.exports = __webpack_public_path__ + "static/images/styles/images/tooltip/bg-pattern.c2d87307.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/tooltip/bg-pattern.png
// module id = 3847
// module chunks = 11